import { ComplaintModalLayout } from "./ComplaintModalLayout";
import Remarks from "../../../../components/remark/Remarks";
import { COMPLAINT_REMARK } from "../../../../api/allApi_List";
import { useComplaintDialog } from "./DialogContext";

ComplaintModalLayout.Remarks = function RemarksSection() {
  const { viewDetails, setComplaintViewDetails, successView } =
    useComplaintDialog();
    console.log(successView ,"successView")
  if (successView) return null;

  return (
    <Remarks
      remarkList={viewDetails.remarks}
      dataId={viewDetails.id}
      apiUrl={COMPLAINT_REMARK}
      setViewDetails={setComplaintViewDetails}
    />
  );
};
